module.exports = __webpack_public_path__ + "static/assets/c4c731bdf4751f9c8da49beae483ba35.png";